// The greeting of Home: "Good morning, Maya" and "Tuesday, 28 October". It reads the clock of the staff member's own machine (a morning
// is the staff member's morning); the page gets the time from the runtime (`now`), so a test fixes it.

/** `Good morning` before noon, `Good afternoon` before six in the evening, else `Good evening`. */
export function greetingWord(now: Date): string {
  const hour = now.getHours();
  if (hour < 12) return "Good morning";
  return hour < 18 ? "Good afternoon" : "Good evening";
}

/** `Tuesday, 28 October`. The words are fixed (British English), whatever language the browser uses. */
export function dateText(now: Date): string {
  const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(now);
  const rest = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long" }).format(now);
  return `${weekday}, ${rest}`;
}

/** The first word of a display name; `null` for a missing or blank name. */
export function firstNameOf(name: string | undefined): string | null {
  const first = name?.trim().split(/\s+/u)[0];
  return first === undefined || first === "" ? null : first;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

/**
 * The first name for the greeting, or `null` when the text is not clearly a person's name. The sign-in provider can give an email address
 * or a user id where a name should be (the live identity does), and "Good morning, maya@lafayette.club" is wrong. A text with `@`, a
 * user id, a text with no letter, or a missing or blank text gives `null`: the greeting then has no name.
 */
export function greetingNameOf(name: string | null | undefined): string | null {
  const text = name?.trim();
  if (text === undefined || text === "" || text.includes("@") || UUID.test(text)) return null;
  if (!/\p{L}/u.test(text)) return null;
  return firstNameOf(text);
}
